<template>
  <div class="main-body">
      <section class="app-main">
        <transition name="fade-transform" mode="out-in">
          <router-view :key="key"/>
        </transition>
      </section>
  </div>
</template>
<script>
export default {
  name: 'AppMain',
  data () {
    return {
      isshow:true
    }
  },
  watch: {
    $route () {
      
    }
  },
  created () {
    
  },
  methods: {
    
  },
  computed: {
    key () {
      return this.$route.fullPath
    }
  }
}
</script>
<style >

</style>
